// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__GrHNp","box":"Profile_box__rD1J0","title":"Profile_title__HZv4t"};